import React from 'react';
import PropTypes from 'prop-types';
import { constructCn } from '../../../../utilities/helperFunctions';

import './RemoteTag.scss';

export const RemoteTag = ({ variant }) => {
    const tagClassName = constructCn(
        'component-JobV3-Elements-RemoteTag',
        `${variant}-embed`
    );
    return <span className={tagClassName}>Remote</span>;
};

RemoteTag.propTypes = {
    variant: PropTypes.oneOf(['job-card', 'single-job']),
};

RemoteTag.defaultProps = {
    variant: 'job-card',
};

RemoteTag.displayName = 'RemoteTag';

export default React.memo(RemoteTag);
